import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Users, Clock, Hash } from 'lucide-react';

function KPIItem({ label, value, sub, Icon, bg }) {
  return (
    <Card className="border border-slate-200 rounded-xl shadow-sm" data-testid={'kpi-' + label.toLowerCase().replace(/\s/g, '-')}>
      <CardContent className="pt-5 pb-5 flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</p>
          <p className="text-3xl font-bold mt-1">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </div>
        <div className={'p-2.5 rounded-lg ' + bg}>
          <Icon className="h-5 w-5 text-white" />
        </div>
      </CardContent>
    </Card>
  );
}

export default function SubmKPI({ entities }) {
  var totalSubs = 0;
  var latestDate = null;

  for (var i = 0; i < entities.length; i++) {
    totalSubs += entities[i].submission_count || 0;
    var d = entities[i].latest_date;
    if (d && (!latestDate || d > latestDate)) latestDate = d;
  }

  var latestStr = 'N/A';
  var latestSub = '';
  if (latestDate) {
    var dt = new Date(latestDate);
    var diff = Date.now() - dt.getTime();
    var hrs = Math.floor(diff / 3600000);
    if (hrs < 1) latestStr = 'Just now';
    else if (hrs < 24) latestStr = hrs + 'h ago';
    else latestStr = Math.floor(hrs / 24) + 'd ago';
    latestSub = dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  // Collect unique fields to count "departments" or similar groupings
  var uniqueEntities = entities.length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="subm-kpi-cards">
      <KPIItem label="Total Submissions" value={totalSubs} sub={uniqueEntities + ' unique entities'} Icon={FileText} bg="bg-slate-800" />
      <KPIItem label="Unique Entities" value={uniqueEntities} sub={'By primary key'} Icon={Users} bg="bg-blue-600" />
      <KPIItem label="Total Fields" value={entities[0] && entities[0].submissions && entities[0].submissions[0] ? Object.keys(entities[0].submissions[0].raw_payload || {}).length : 0} sub="Per submission" Icon={Hash} bg="bg-emerald-600" />
      <KPIItem label="Latest Submission" value={latestStr} sub={latestSub} Icon={Clock} bg="bg-amber-500" />
    </div>
  );
}
